import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-arrow-up-lined",
  "use": "rt-base-arrow-up-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-arrow-up-lined\"><path d=\"M135.8 737.9L512 361.7l376.2 376.2c16.4 16.4 43.1 16.4 59.5 0s16.4-43.1 0-59.5L565.1 295.8c-14.2-14.2-33-22-53.1-22s-38.9 7.8-53.1 22L76.3 678.4c-16.4 16.4-16.4 43.1 0 59.5 16.5 16.4 43.1 16.4 59.5 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/arrow-up-lined.svg
// module id = 1638
// module chunks = 228